/**
 * Tri druhy čísla zákazky (KOLO 200, `services/cisla_zakaziek.py`).
 *
 * User: *„V je len pre výpočty, AA pre zákazky ako keby Tandem a Z by bolo
 * ako keby malé zákazky pre nás, čo Tandem nevyrába, preto nemá AA."*
 */

export type DruhCisla = "vypocet" | "zakazka" | "mala";

export const DRUHY_CISLA: { druh: DruhCisla; nazov: string; popis: string }[] = [
  {
    druh: "vypocet",
    nazov: "Výpočet",
    popis: "Číslo V… pridelí Rozpočet, AA doplníš neskôr.",
  },
  {
    druh: "zakazka",
    nazov: "Zákazka AA",
    popis: "Zadáš číslo AA — ide rovno do výroby, bez výpočtu.",
  },
  {
    druh: "mala",
    nazov: "Malá zákazka bez AA",
    popis: "Tandem ju nevyrába — číslo Z… pridelí Rozpočet a AA nikdy nedostane.",
  },
];

interface CislaZakazky {
  cislo_zakazky: string;
  vypocet_cislo?: string | null;
  cislo_z?: string | null;
}

/** Druh podľa čísel zákazky — Z je trvalé, V hlavné = výpočet bez AA. */
export function druhZakazky(z: CislaZakazky): DruhCisla {
  if (z.cislo_z) return "mala";
  if (z.vypocet_cislo && z.vypocet_cislo === z.cislo_zakazky) return "vypocet";
  return "zakazka";
}

const CISLO_AA = /^[A-Za-z]{1,4}\d{2,6}$/;

/**
 * Tvar čísla AA — rovnaké pravidlo, akým Rozpočet číslo spozná v Určení
 * (`topsolid_raw._CISLO_ZAKAZKY`). V… a Z… prideľuje Rozpočet sám.
 */
export function jeCisloAa(text: string): boolean {
  const t = text.trim();
  return CISLO_AA.test(t) && !/^[VZ]\d+$/i.test(t);
}
